import { Button, Container, Typography, Box, Paper } from '@mui/material'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import DataTable from 'src/components/common/DataTables/DataTable'
import { $APP_NAME } from 'src/constants'
import BoxDialog from './components/BoxDialog'
import { Circle } from '@mui/icons-material'
import { useEffect, useState } from 'react'
import { useGetBoxesQuery } from 'src/_api/shipmentBox'
import { omitBy } from 'lodash'
import moment from 'moment'

const $COLUMN_WIDTH = 200
export default function Boxes() {
  const { t } = useTranslation()

  const [params, setParams] = useState({ searchKey: null, page: 1, limit: 20 })

  const {
    data: boxes,
    isLoading: boxesLoading,
    isFetching: boxesFetching
  } = useGetBoxesQuery(omitBy(params, v => !v))

  //===========Data table Pagingation and row count=========
  const [rowCount, setRowCount] = useState(0)
  useEffect(() => {
    if (!!boxes) return setRowCount(boxes?.length)
  }, [boxes])

  const pageChangeHandler = (page) => {
    setParams((prev) => ({ ...prev, page }))
  }


  let columns = [
    { field: "boxName", sortable: false, headerName: t("Box Name"), width: $COLUMN_WIDTH * 1.5 },
    { field: "length", valueGetter: ({ row }) => row?.dimensions?.length, sortable: false, headerName: t("Length"), width: $COLUMN_WIDTH * 0.5 },
    { field: "height", valueGetter: ({ row }) => row?.dimensions?.height, sortable: false, headerName: t("Height"), width: $COLUMN_WIDTH * 0.5 },
    { field: "width", valueGetter: ({ row }) => row?.dimensions?.width, sortable: false, headerName: t("Width"), width: $COLUMN_WIDTH * 0.5 },
    { field: "weight", valueGetter: ({ row }) => row?.weight, sortable: false, headerName: t("Weight"), width: $COLUMN_WIDTH * 0.5 },
    {
      field: "default",
      sortable: false,
      renderCell: ({ value }) => <Circle sx={{ color: value ? "success.main" : "" }} />,
      headerName: t("Pre-selected"),
      width: $COLUMN_WIDTH * 0.8,
      align: "center"
    },
    {
      field: "thirdPartyDefault",
      sortable: false,
      renderCell: ({ value }) => <Circle sx={{ color: value ? "success.main" : "" }} />,
      headerName: t("Auto-assign"),
      width: $COLUMN_WIDTH * 0.8,
      align: "center"
    },
    //{ field: "createdAt", valueGetter: ({ value }) => moment(value).format("DD/MM/YYYY"), sortable: false, headerName: t("Created At"), width: $COLUMN_WIDTH * 0.8 },
  ];

  const [selectedBox, setSelectedBox] = useState(null)
  const [openDialog, setOpenDialog] = useState(false)

  const [isEditing, setIsEditing] = useState(false)

  const openBoxDialog = (row) => {
    if (!!row) {
      setIsEditing(true)
      setSelectedBox(row)
    }
    setOpenDialog(true)
  }

  const closeBoxDialog = () => {
    setOpenDialog(false)
    setSelectedBox(null)
    setIsEditing(false)
  }


  return (
    <>
      <Helmet> Boxes | {$APP_NAME} </Helmet>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h2">{t("Boxes")}</Typography>
        <Button variant="contained" color="primary" onClick={() => openBoxDialog()}>
          {t("Add Box")}
        </Button>
        <BoxDialog
          open={openDialog}
          onClose={closeBoxDialog}
          box={selectedBox}
          isEditing={isEditing}
        />
      </Box>
      <Paper sx={{ height: "75vh", mt: 1 }}>
        <DataTable
          rows={boxes ?? []}
          columns={columns}
          loading={boxesLoading || boxesFetching}
          rowCount={rowCount}
          page={params?.page}
          pageSize={20}
          onRowClick={({ row }) => openBoxDialog(row)}
          onPageChange={pageChangeHandler}
          checkboxSelection={false}
          customComponents={["Pagination"]}
        />
      </Paper>
    </>
  )
}
